import React from "react";
interface Metric {
    description: string;
    PCTL: number;
    bank: number;
}
interface BankResult {
    metrics: Record<string, Metric>;
    bank_name: string;
}
interface Data {
    bank_1: {
        result: BankResult;
    };
    bank_2: {
        result: BankResult;
    };
}
interface BankComparisonProps {
    data: Data;
}
export const BankComparison: React.FC<BankComparisonProps> = ({ data }) => {
    if (
        !data ||
        !data.bank_1 ||
        !data.bank_2 ||
        !data.bank_1.result ||
        !data.bank_2.result ||
        !data.bank_1.result.metrics ||
        !data.bank_2.result.metrics
    ) {
        console.error("Data is missing or incomplete:", data);
        return <></>;
    }
    return (
        <>
            {Object.keys(data).length > 0 ? (
                <div className="metrics-container-box">
                    <div className="metrics-container">
                        {Object.entries(data.bank_1.result.metrics).map(
                            ([metricKey, bank1Metric]) => {
                                const bank1TypedMetric = bank1Metric;
                                const bank2Metric = data.bank_2.result.metrics[
                                    metricKey
                                ];

                                return (
                                    <div
                                        key={metricKey}
                                        className="metric-box bankComp-metric-box"
                                    >
                                        <div className="titlemetric">
                                            <div className="metric-title">{metricKey}</div>
                                            <div className="metric-subtitle">
                                                {bank1TypedMetric.description}
                                            </div>
                                        </div>
                                        <div className="percentile-bankcomp-section">
                                            <div
                                                style={{ fontSize: "25px" }}
                                                className={
                                                    bank1TypedMetric.PCTL < 51
                                                        ? "red-text-percentile"
                                                        : bank1TypedMetric.PCTL >= 51 &&
                                                            bank1TypedMetric.PCTL <= 70
                                                            ? "skyblue-text-percentile"
                                                            : "metric-percentile"
                                                }
                                            >
                                                <div className="bankCompare-pctl-text">{bank1TypedMetric.PCTL} <div className="pctl-heading" style={{marginLeft:'5px'}}> PCTL</div> </div>
                                            </div>
                                            <div
                                                style={{ fontSize: "25px" }}
                                                className={
                                                    bank2Metric.PCTL < 51
                                                        ? "red-text-percentile"
                                                        : bank2Metric.PCTL >= 51 && bank2Metric.PCTL <= 70
                                                            ? "skyblue-text-percentile"
                                                            : "metric-percentile"
                                                }
                                            >
                                                <div className="bankCompare-pctl-text">{bank2Metric.PCTL}<div className="pctl-heading" style={{marginLeft:'5px'}}> PCTL</div>  </div>
                                            </div>
                                        </div>

                                        <div className="barBoxGraph-section bank-comp-barBoxGraph">
                                            <div
                                                className="bank-box bank-box-comp"
                                                style={{
                                                    height:
                                                        bank1TypedMetric.bank > bank2Metric.bank
                                                            ? "70px"
                                                            : "60px",
                                                }}
                                            >
                                                <span className="bar-value">
                                                    {bank1TypedMetric.bank
                                                        .toString()
                                                        .replace(/^(\d+\.\d{2}).*$/, "$1")}%
                                                </span>
                                            </div>

                                            <div
                                                className="peer-box peer-box-comp"
                                                style={{
                                                    height:
                                                        bank2Metric.bank > bank1TypedMetric.bank
                                                            ? "70px"
                                                            : "60px",
                                                    background:
                                                        "linear-gradient(to bottom, #bef2dd, #a7d6e7, #9abbf4)",
                                                }}
                                            >
                                                <span className="bar-value">
                                                    {bank2Metric.bank
                                                        .toString()
                                                        .replace(/^(\d+\.\d{2}).*$/, "$1")}%
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        )}
                    </div>
                    <div className="legend-section">
                        <div className="legend-row">
                            <div className="legend-item">
                                <span
                                    className="legend-color"
                                    style={{ backgroundColor: "#ff3130" }}
                                ></span>
                                <span className="legend-label">&lt; 51 PCTL</span>
                            </div>
                            <div className="legend-item">
                                <span
                                    className="legend-color"
                                    style={{ backgroundColor: "#37b6ff" }}
                                ></span>
                                <span className="legend-label">51-70 PCTL</span>
                            </div>
                            <div className="legend-item">
                                <span
                                    className="legend-color"
                                    style={{ backgroundColor: "#008424" }}
                                ></span>
                                <span className="legend-label">&gt; 70 PCTL</span>
                            </div>
                        </div>
                        <div className="legend-row">
                            <div className="legend-item">
                                <span
                                    className="legend-color"
                                    style={{
                                        background: "linear-gradient(to bottom, #5adbe4, #0451b0)",
                                    }}
                                ></span>
                                <span className="legend-label">
                                    {data.bank_1.result.bank_name}
                                </span>
                            </div>
                            <div className="legend-item">
                                <span
                                    className="legend-color"
                                    style={{
                                        background:
                                            "linear-gradient(to bottom, #bef2dd, #a7d6e7, #9abbf4)",
                                    }}
                                ></span>
                                <span className="legend-label">
                                    {data.bank_2.result.bank_name}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
};